import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CloseAccountingCash from '@/pages/close-accounting-cash/CloseAccountingCash.vue';

export default {
  path: '/close-accounting-cash',
  name: 'CloseAccountingCash',
  components: {
    mainContent: CloseAccountingCash,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'close-accounting-cash',
    },
    breadcrumb: {
      title: 'Fechamento de caixa',
      paths: [{ title: 'Controle de caixa' }, { title: 'Fechamento' }],
    },
  },
};
